<script>
  const tutorialItems = [
    {
      titulo: "1. Locais de Atendimento",
      icone: "fa-map-marker-alt",
      desc: "Configure onde seus atendimentos ocorrem. Pode ser um endereço físico ou links (Zoom, Meet, WhatsApp). É aqui que você define se o serviço é presencial ou online."
    },
    {
      titulo: "2. Estrutura do Formulário",
      icone: "fa-list-ul",
      desc: "Escolha quais informações seu cliente precisa preencher. Você pode marcar CPF, E-mail e Nascimento como obrigatórios, opcionais ou ocultos conforme sua necessidade."
    },
    {
      titulo: "3. Agendamento Manual",
      icone: "fa-user-plus",
      desc: "Na aba de 'Horários Abertos', use o botão de agendamento para registrar clientes que ligaram ou enviaram mensagem, garantindo que o horário seja bloqueado na sua agenda."
    },
    {
      titulo: "4. Integração Google Calendar", 
      icone: "fa-calendar-alt",
      desc: "Conecte sua conta para que cada agendamento seja criado automaticamente no seu Google Agenda, com direito a lembretes customizados no seu celular."
    },
    {
      titulo: "5. Cupons e Créditos",
      icone: "fa-ticket-alt",
      desc: "Use a aba 'Minha Assinatura' para resgatar cupons de desconto ou dias grátis. A matemática é automática: resgatou, o desconto entra no próximo PIX."
    }
  ];
</script>

<div class="tutorial-container">
  <h2><i class="fas fa-graduation-cap"></i> Primeiros Passos</h2>
  <p class="text-muted">Aprenda a dominar as funcionalidades principais em poucos minutos.</p>

  <div class="tutorial-grid">
    {#each tutorialItems as item}
      <div class="tutorial-card">
        <div class="icon-box"><i class="fas {item.icone}"></i></div>
        <h3>{item.titulo}</h3>
        <p>{item.desc}</p>
      </div>
    {/each}
  </div>
</div>

<style>
  .tutorial-container { max-width: 900px; margin: 0 auto; padding: 20px; }
  .tutorial-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 20px; margin-top: 30px; }
  .tutorial-card { background: white; padding: 25px; border-radius: 12px; border: 1px solid #e0e6e2; box-shadow: 0 4px 6px rgba(0,0,0,0.02); transition: 0.3s; }
  .tutorial-card:hover { transform: translateY(-5px); border-color: var(--primary); }
  .icon-box { width: 50px; height: 50px; background: #eef5f0; color: var(--primary); border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; margin-bottom: 15px; }
  h2 { color: #4a6c56; }
  h3 { margin: 0 0 10px 0; color: #2d3748; }
  .text-muted { color: #718096; margin-bottom: 20px; }

  @media (max-width: 640px) {
    .tutorial-container { padding: 12px; }
    .tutorial-grid { grid-template-columns: 1fr; }
    .tutorial-card { padding: 20px; }
  }
</style>